<template>
  <VDialog v-if="isOpen" :open="isOpen" modal @close="dismissModal" :headline="title" style="--dialog-min-inline-size: 500px; --dialog-max-inline-size: 580px;">
    <template #body>
      <div v-if="loading" class="overlay">
        <VProgressRing connotation="cta" :size="-3" />
      </div>
      <div class="gridMargin">
        <div class="marginBottom">
          <p class="sub-title no-margin paddingBottom">Export format</p>
          <VTextField v-model="csvExportFormatDdl" readonly placeholder="CSV" aria-label="csv" appearance="ghost" class="vivid-input read-only-field"></VTextField>
        </div>
        <div class="marginBottom">
          <p class="sub-title no-margin paddingBottom">Delimiter</p>
          <VSelect v-model="csvExportDelimiterDdl" aria-label="delimiter" appearance="ghost" class="vivid-input" fixed-dropdown>
            <VOption value="comma" text="Comma" />
            <VOption value="pipe" text="Pipe" />
            <VOption value="semicolon" text="Semicolon" />
            <VOption value="colon" text="Colon" />
            <VOption value="tab" text="Tab" />
          </VSelect>
        </div>
        <div class="marginBottom">
          <p class="sub-title no-margin paddingBottom">Date Range</p>
          <div class="date-display">
            <span>{{ formattedStart }}</span> → <span>{{ formattedEnd }}</span>
          </div>
        </div>
      </div>
    </template>
    <template #action-items>
      <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" :disabled="loading" @click="dismissModal" />
      <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" :label="buttonText" :disabled="loading" :pending="loading" @click="csvExportToEmailSubmit" />
    </template>
  </VDialog>
</template>

<script>
import apiInterceptor from '@/shared/apiInterceptor';
import moment from "moment-timezone";
import { useUIStore } from '@/stores/ui';
import { environment } from '@/shared/env.js';
export default {
  name: "exportCSVAnalytics",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    title: {
      type: String
    },
    startDate: String,
    endDate: String,
    timezone: String,
    dateFormat: String,
  },
  data() {
    return {
      loading: false,
      buttonText: 'Export',
      csvExportFormatDdl: "csv",
      csvExportDelimiterDdl: "comma",
      downloadLoader: false,
    }
  },
  methods: {
    dismissModal() {
      this.resetToDownloadState();
      this.$emit('close');
    },
    resetToDownloadState() {
      this.loading = false;
      this.buttonText = 'Export';
    },
    async csvExportToEmailSubmit() {
      try {
        this.loading = true;
        this.buttonText = 'Exporting...';
        const start = moment
          .tz(this.startDate, this.dateFormat, this.timezone)
          .startOf("day")
          .utc()
          .format("MM/DD/YYYY HH:mm");

        const end = moment
          .tz(this.endDate, this.dateFormat, this.timezone)
          .endOf("day")
          .utc()
          .format("MM/DD/YYYY HH:mm");

        const delimiter = this.csvExportDelimiterDdl;
        const qp =
          `start_date=${encodeURIComponent(start)}` +
          `&end_date=${encodeURIComponent(end)}` +
          `&csv_delimiter=${encodeURIComponent(delimiter)}`;
        const resp = await apiInterceptor.post(
          environment("VUE_APP_APIGEE_API_URL") + `analytics/export?${qp}`,
          {}
        );
        useUIStore().updateToast({
          open: true,
          message: resp.message || "CSV export initiated successfully! You will receive an email with the download link shortly.",
          type: "success",
        });
        this.dismissModal();

      } catch (error) {
        this.resetToDownloadState();
        useUIStore().updateToast({
          open: true,
          message: error?.response?.data?.detail || "Something went wrong!",
          type: "danger",
        });
      }
    },
  },
  computed: {
    formattedStart() {
      return moment
        .tz(this.startDate, this.dateFormat, this.timezone)
        .format("MMM DD, YYYY");
    },
    formattedEnd() {
      return moment
        .tz(this.endDate, this.dateFormat, this.timezone)
        .format("MMM DD, YYYY");
    },
  }
}
</script>

<style scoped>
.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  z-index: 10;
}
.gridMargin {
  position: relative;
}
.marginBottom {
  margin-bottom: 16px;
}
.paddingBottom {
  padding-bottom: 8px;
}
.no-margin {
  margin: 0;
}
.read-only-field {
  opacity: 0.7;
}
.date-display {
  background: var(--gray-01);
  padding: 10px 12px;
  border-radius: 5px;
  font-size: 14px;
  color: var(--black);
}
</style>
